import { z } from "zod";
const translationPath =
  "page.4uMarCom.automationRules.marcom_distributionList.errors.";

const listSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "list" }
);

export const distributionListSchema = z
  .object({
    id: z.string().optional(),
    list: listSchema,
  })
  .superRefine((val, ctx) => {});

export type TDistributionListsForm = z.infer<typeof distributionListSchema>;
